import {
  CarouselQueryDataResult,
  getCarouselRowQueryData,
} from '../../../../components/carousel'
import { css } from '@fable/theme'
import { useErrorModal, useClubsList } from '../../../../hooks'
import Loader from '../../../../components/loader'
import { PageContainerV2 } from 'components/v2'
import { HomeClubsRow } from './HomeClubsRow'
import { Club } from '@fable/types'
import { HomePopularClubsList } from './HomePopularClubsList'

const HomeClubsList = () => {
  const { data, loading, error } = useClubsList({
    listId: '3BmiaeUlIImDqnaKYN40AI',
    queryKey: 'homeClubCarousels',
  })

  useErrorModal(error)

  return (
    <div
      className={css`
        overflow: hidden;
        padding-top: 8px;
      `}
    >
      <PageContainerV2
        className={css`
          overflow: visible;
        `}
      >
        <section
          className={css`
            padding-bottom: 80px;
          `}
        >
          <HomePopularClubsList />
          {loading ? (
            <Loader />
          ) : (
            <div className="fade" data-testid="homeClubsCarouselList">
              {data.map((result: CarouselQueryDataResult, i: number) => {
                const { title, items } = getCarouselRowQueryData({
                  data: result,
                })

                return (
                  <HomeClubsRow key={i} title={title} items={items as Club[]} />
                )
              })}
            </div>
          )}
        </section>
      </PageContainerV2>
    </div>
  )
}

export default HomeClubsList
